import { render, staticRenderFns } from "./magnifier.vue?vue&type=template&id=59ae966e&scoped=true&"
import script from "./magnifier.vue?vue&type=script&lang=ts&"
export * from "./magnifier.vue?vue&type=script&lang=ts&"
import style0 from "./magnifier.vue?vue&type=style&index=0&id=59ae966e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ae966e",
  null
  
)

export default component.exports